import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

import VueNativeSock from 'vue-native-websocket';

Vue.use(VueNativeSock, "wss://localhost:9090",
  { store: store, format: 'json', connectManually: true, reconnection:true });

import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import awsmobile from "@/aws-exports";

Amplify.configure(awsmobile);

Vue.config.productionTip = false;

Vue.use(AmplifyPlugin, AmplifyModules);

import IdleVue from 'idle-vue'
Vue.use(IdleVue,{store,idleTime: 60000,startAtIdle: false});

// import Tabulator from 'tabulator-tables';
// Vue.use(Tabulator);
// import VueTabulator from 'vue-tabulator';
// Vue.use(VueTabulator, {
//   name: 'VueTabulator'
// });
// import 'tabulator-tables/dist/css/tabulator_midnight.min.css';
// <style lang='scss'>
//   import "~vue-tabulator/dist/scss/tabulator_midnight.scss";
// </style>


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

/* <style lang='scss'>
  @import "~vue-tabulator/dist/scss/tabulator_midnight.min.css";
</style> */